var Loan = require('./lib/Loan');
var MonthlyFixedAmortizationLoan = require('./lib/MonthlyFixedAmortizationLoan');
var MonthlyFixedPaymentLoan = require('./lib/MonthlyFixedPaymentLoan');
var utils = require('./lib/utils');
module.exports = {
  Loan: Loan,
  MonthlyFixedAmortizationLoan: MonthlyFixedAmortizationLoan,
  MonthlyFixedPaymentLoan: MonthlyFixedPaymentLoan,
  utils: utils
};